/**
 * Bonmodell für die native Bridge aus dem, was der Server bereits gebildet hat. Die Kasse
 * bildet keinen Belegtext und rechnet nichts: Zeilen und RKSV-Code kommen unverändert aus
 * `details` des Druckauftrags (`POST /kassen/:id/belege/:nr/druckauftrag`, gerendert mit
 * `rendereBelegText` im RKSV-Kern). Grenzen wie in `hardware/Bonmodell.kt` der App.
 */
import type { Bonmodell } from './bridge';

export const BONMODELL_FORMAT = 'bilanx-bon/1' as const;

export const BON_GRENZEN = {
  zeilen: 400,
  zeichenJeZeile: 200,
  titel: 40,
  qr: 1000,
} as const;

/** Liest `details` eines Druckauftrags; null, wenn sie kein druckbarer Bon sind. */
export function bonmodellAusDetails(details: Record<string, unknown>): Bonmodell | null {
  const zeilen = details.zeilen;
  if (!Array.isArray(zeilen) || !zeilen.every((z): z is string => typeof z === 'string')) {
    return null;
  }
  const bon: Bonmodell = { format: BONMODELL_FORMAT, zeilen: [...zeilen] };
  if (typeof details.titel === 'string' && details.titel !== '') {
    bon.titel = details.titel;
  }
  if (typeof details.qrCode === 'string' && details.qrCode !== '') {
    bon.qrCode = details.qrCode;
  }
  if (details.kopie === true) {
    bon.kopie = true;
  }
  return pruefeBonmodell(bon) === null ? bon : null;
}

/** Grund, warum die App den Bon ablehnen würde, oder null. */
export function pruefeBonmodell(bon: Bonmodell): string | null {
  if (bon.zeilen.length > BON_GRENZEN.zeilen) {
    return 'Zu viele Zeilen';
  }
  if (bon.zeilen.some((z) => z.length > BON_GRENZEN.zeichenJeZeile)) {
    return 'Zeile zu lang';
  }
  if (bon.titel !== undefined && bon.titel.length > BON_GRENZEN.titel) {
    return 'Titel zu lang';
  }
  if (bon.qrCode !== undefined) {
    if (bon.qrCode.length > BON_GRENZEN.qr) {
      return 'QR-Inhalt zu lang';
    }
    if (!/^[\x20-\x7e]*$/.test(bon.qrCode)) {
      return 'QR-Inhalt mit unzulässigen Zeichen';
    }
  }
  if (
    bon.zeilen.every((z) => z.trim() === '') &&
    bon.titel === undefined &&
    bon.qrCode === undefined
  ) {
    return 'Leerer Bon';
  }
  return null;
}
